import { NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import {
  LayoutDashboard, Calendar, Users, Phone, Scissors, Clock,
  Bot, MessageSquare, BarChart3, Settings, ScrollText, LogOut, Building2, TrendingUp, BookOpen, UserCog, ShieldCheck
} from "lucide-react";

export const NAV_ITEMS = [
  { to: "/app", label: "Dashboard", icon: LayoutDashboard, end: true, tid: "nav-dashboard" },
  { to: "/app/appointments", label: "Appointments", icon: Calendar, tid: "nav-appointments" },
  { to: "/app/customers", label: "Customers", icon: Users, tid: "nav-customers" },
  { to: "/app/calls", label: "Calls", icon: Phone, tid: "nav-calls" },
  { to: "/app/services", label: "Services", icon: Scissors, tid: "nav-services" },
  { to: "/app/team", label: "Team", icon: UserCog, tid: "nav-team" },
  { to: "/app/hours", label: "Business Hours", icon: Clock, tid: "nav-hours" },
  { to: "/app/ai", label: "AI Receptionist", icon: Bot, tid: "nav-ai" },
  { to: "/app/test", label: "Test Simulator", icon: MessageSquare, tid: "nav-test" },
  { to: "/app/analytics", label: "Analytics", icon: BarChart3, tid: "nav-analytics" },
  { to: "/app/knowledge", label: "Knowledge", icon: BookOpen, tid: "nav-knowledge" },
  { to: "/app/recap", label: "Your Results", icon: TrendingUp, tid: "nav-recap" },
  { to: "/app/business", label: "Business", icon: Building2, tid: "nav-business" },
  { to: "/app/audit", label: "Audit Log", icon: ScrollText, tid: "nav-audit" },
  { to: "/app/settings", label: "Settings", icon: Settings, tid: "nav-settings" },
];

export default function Sidebar() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  return (
    <aside className="hidden lg:flex w-64 fixed inset-y-0 bg-slate-950 text-slate-100 flex-col border-r border-slate-800 z-40" data-testid="sidebar">
      <div className="px-6 py-6 border-b border-slate-800">
        <div className="flex items-center gap-2">
          <div className="w-9 h-9 rounded-xl bg-blue-600 flex items-center justify-center font-bold text-white">A</div>
          <div>
            <div className="font-heading font-bold text-lg tracking-tight">ASFA</div>
            <div className="text-xs text-slate-400">AI Receptionist</div>
          </div>
        </div>
      </div>
      <nav className="flex-1 px-3 py-4 space-y-0.5 overflow-y-auto">
        {NAV_ITEMS.map((it) => (
          <NavLink key={it.to} to={it.to} end={it.end} data-testid={it.tid}
            className={({ isActive }) =>
              `flex items-center gap-3 px-3 py-2 rounded-lg text-sm transition-colors ${
                isActive ? "bg-blue-600 text-white" : "text-slate-300 hover:bg-slate-800 hover:text-white"
              }`
            }>
            <it.icon className="w-4 h-4" />
            {it.label}
          </NavLink>
        ))}
        {user?.is_admin && (
          <NavLink to="/app/admin" data-testid="nav-admin"
            className={({ isActive }) =>
              `flex items-center gap-3 px-3 py-2 rounded-lg text-sm transition-colors ${
                isActive ? "bg-blue-600 text-white" : "text-slate-300 hover:bg-slate-800 hover:text-white"
              }`
            }>
            <ShieldCheck className="w-4 h-4" /> Platform Admin
          </NavLink>
        )}
      </nav>
      <div className="px-4 py-4 border-t border-slate-800">
        <div className="text-xs text-slate-400 mb-2">{user?.email}</div>
        <button data-testid="logout-btn" onClick={() => { logout(); nav("/"); }}
          className="flex items-center gap-2 text-sm text-slate-300 hover:text-white">
          <LogOut className="w-4 h-4" /> Sign out
        </button>
      </div>
    </aside>
  );
}
